// this is going to be global contract in the lib
import { eBranches } from "../../contracts";
import { Scoreboards } from "../../constants";
export const mapGamePart = (x) => {
    x.gamePart = x.liveGameState
        && x.liveGameState.gamePart
        && !Scoreboards[eBranches[x.sportId]]
        ? x.liveGameState.gamePart
        : "";
    return x;
};
//# sourceMappingURL=mapGamePart.js.map